import axios from "axios";
import { toast } from "react-toastify";

import { SyncPricingFunctionResponseBodyType } from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";

const syncPriceTestMetafields = async () => {
  const resp = await api.get<SyncPricingFunctionResponseBodyType>(
    "/v2/price-test-metafields/sync",
    {}
  );
  return resp.data;
};

export const useSyncPriceTestMetafields = () => {
  return useMutation<string, Error>({
    mutationFn: syncPriceTestMetafields,
    onError(error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 503) {
          // Do nothing
        } else {
          toast.error(`Something went wrong... ${error.message}`);
        }
      }
    },
  });
};
